var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p10"},[_c('config-item',{attrs:{"label":"背景色"}},[_c('config-color-picker',{attrs:{"value":_vm.bgColor},on:{"input":_vm.setBgColor}})],1),_c('config-item',{attrs:{"label":"背景图片"}},[_c('FaImageUpload',{attrs:{"value":_vm.bgImage,"maxCount":1},on:{"input":_vm.setBgImage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }